Vendd.Scripts.load(function () {
    var $form = $('.x-contact-form'), $submitButton, form, formData, filedata;

    if ($form.length < 1)
        return;

    $submitButton = $('.js-submit-button', $form);

    form = $form.get(0);

    formData = {
        firstName: $("input[name='firstName']", $form).val() ? $("input[name='firstName']", $form).val() : "",
        lastName: $("input[name='lastName']", $form).val() ? $("input[name='lastName']", $form).val() : "",
        email: $("input[name='email']", $form).val() ? $("input[name='email']", $form).val() : "",
        message: $("textarea[name='message']", $form).val() ? $("textarea[name='message']", $form).val() : "",
        newsletter: false,
        subject: $("select[name='subject']", $form).val() ? $("select[name='subject']", $form).val() : "",
        reCaptchaCode: "",
        contactFileUpload: ""
    };
    // reCAPTCHA
    var captchaId = "contactCaptcha";
    var captchaWidgetId;
    var $captchaElement = $form.find("#" + captchaId);
    var $captchaContainer = $form.find('.recaptcha-container');
    var captchaEnabled = $captchaElement.length > 0 ? true : false;
    var $fileUploadElement = $form.find("#cwfileupload");
    var fileUploadEnabled = $fileUploadElement.length > 0 ? true : false;
    var subjectEnabled = $('.x-contact-form .form-row select[name=subject]').length > 0;

    form.initRecaptcha = function () {

        if (!captchaEnabled)
            return;

        var sitekey = $captchaElement.data("sitekey");
        if (sitekey) {
            captchaEnabled = true;
            captchaWidgetId = grecaptcha.render(captchaId, {
                'sitekey': sitekey,
                'callback': form.recaptchaCallback
            });
        }
    };

    form.recaptchaCallback = function () {
        form.validateRecaptcha();
    };

    form.resetRecaptcha = function () {
        // Website must only verify the user's reCAPTCHA response token (g-recaptcha-response) once. 
        // If a verify attempt has been made with a particular token, it cannot be used again. 
        // Call grecaptcha.reset() to ask the end user to verify with reCAPTCHA again.
        if (captchaEnabled)
            grecaptcha.reset(captchaWidgetId);
    };

    form.removeRecaptcha = function () {
        $captchaElement.remove();
    };

    form.validateRecaptcha = function () {
        if (!captchaEnabled)
            return true;

        formData.reCaptchaCode = $captchaElement.find('.g-recaptcha-response').val();

        var res = false;

        if (formData.reCaptchaCode) {
            $captchaContainer.find('.recaptcha-required').removeClass('error');
            res = true;
        }
        else {
            $captchaContainer.find('.recaptcha-required').addClass('error');
        }

        return res;
    };

    form.validateFileUpload = function () {
        if (!fileUploadEnabled)
            return true;

        if ($("#cwfileupload", $form).data("mandatoryfileupload") === "True" && $("#cwfileupload", $form).get(0).files.length === 0) {
            $('.cwfileupload-required', $form).show();
            return false;
        }

        return true;
    };

    form.loading = function (loading) {
        if (loading) {
            $form.addClass('x-loading');
        } else {
            $form.removeClass('x-loading');
        }
    };

    form.onSuccess = function (envelope) {
        form.loading(false);

        var data = envelope.message.data;

        if (data.success && data.code === "Contact_OperationSuccesful") {
            $('.js-error', $form).hide();
            $('.js-content', $form).hide();
            $('.js-success', $form).show();

            $('html,body').animate({ scrollTop: $('.js-success', $form).offset().top - 100 }, 400);

            /* Track Contact */
            if (typeof fbPixelTracker !== 'undefined' && typeof fbPixelCanTrack !== 'undefined') {
                if (fbPixelTracker && fbPixelTracker.Properties.FacebookPixelId && fbPixelCanTrack) {
                    fbq('track', 'Contact');
                }
            }
            /* END Track Contact */

            form.removeRecaptcha();
            form.reset();
        } else {
            $('.js-error', $form).show();
            form.resetRecaptcha();
        };
    };

    form.onFailure = function (envelope) {
        form.loading(false);

        $('.js-error', $form).show();
    };

    form.checkConsents = function () {
        var data = [];

        var checkboxes = $('.form-row.consent.checkbox');
        $.each(checkboxes, function (e, el) {
            var chkbx = $('.checkbox-wrapper input', el);
            data.push({ type: chkbx.attr('id'), source: 'Contact Form', approved: chkbx.prop("checked") });
        });

        if (data.length > 0) {
            window.ConsentsManager.insertConsents(data);
        } else {
            if (filedata)
                filedata.submit();
            else
                form.submit();
        }

    }

    form.submit = function () {
        form.loading(true);

        if ($('#chkNewsletter').length > 0) formData.newsletter = $('#chkNewsletter').prop("checked");

        Vendd.MessageBus.publishAsync(form, new Vendd.Contact.Messages.Submit(
            formData.email,
            formData.firstName,
            formData.lastName,
            formData.message,
            formData.newsletter,
            '', '', '', '', '', '',
            formData.reCaptchaCode,
            subjectEnabled ? formData.subject : 0,
            formData.contactFileUpload
        ));
    };

    form.reset = function () {
        $('input[name="firstName"]', $form).val("");
        $('input[name="lastName"]', $form).val("");
        $('input[name="email"]', $form).val("");
        $('textarea[name="message"]', $form).val("");
        $('select[name="subject"]', $form).val("");
        $('input[name="PrivacyPolicy"]', $form).prop('checked', false);
        cf.reset();
    };

    form.clearUploadErros = function () {
        $('.cwfileupload-required', $form).hide();
        $('.cwfileupload-invalid', $form).hide();
        $('.cwfileupload-exceeds-max-size', $form).hide();
    };

    form.submitSelector = function () {
        if (filedata)
            filedata.submit();
        else
            form.submit();
    };

    $form.on('click', '.js-submit-button', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var val1 = cf.validate();
        var val2 = form.validateRecaptcha();
        var val3 = form.validateFileUpload();

        if (val1 && val2 && val3) {
            if (LhApp.Context.IsConsentsEnabled) {
                form.checkConsents();
            } else {
                if (filedata)
                    filedata.submit();
                else
                    form.submit();
            }
        } else {
            if ($('.form-row.with-error', $form).length > 0) {
                $('html,body').animate({ scrollTop: $('.form-row.with-error').first().offset().top - 100 }, 400);
            }
        }

    });

    $form.on('click', '.js-reset-button', function (e) {
        e.preventDefault();
        e.stopPropagation();

        form.reset();
    });

    $form.on('blur', 'input[name]:not([type="checkbox"]), textarea[name]', function (e) {
        form.setField($(this));
    });

    $form.on('keyup', 'input[name]:not([type="checkbox"]), textarea[name]', function (e) {
        form.setField($(this));
    });

    $form.on('change', 'select[name]', function (e) {
        form.setField($(this));
    });

    form.setField = function (field) {

        var fieldName = field.attr('name');

        formData[fieldName] = field.val() || 0;

        cf.validate(fieldName);
    }

    //init validation options
    var validationOptions = {
        firstName: {
            required: 'firstname-required'
        },
        lastName: {
            required: 'lastname-required'
        },
        email: {
            required: 'email-required',
            isEmail: 'email-invalid'
        },
        message: {
            required: 'message-required'
        }
    };
    if (subjectEnabled) {
        validationOptions.subject = {
            required: 'subject-required'
        }
    }

    //add consent validations
    $.each($('div.consent.checkbox[data-required]'), function (e, el) {
        var consentType = $('input', el).attr('name');
        validationOptions[consentType] = {
            checkboxRequired: consentType + '-required'
        };
    });


    $form.validationEngine(validationOptions);
    var cf = $form.data('validationEngine');

    if ($(".view-terms", $form).length > 0) {
        $(".view-terms", $form).fancybox({
            touch: false
        });
    }

    var $consents = $('.form-row.consent input[type="checkbox"]', $form);

    $consents.on('click', function () {
        var fieldName = $(this).attr('name');

        cf.validate(fieldName);
    });

    $('.cwfileupload', $form).on('click', function () {
        $('.cwuploaded-file', $form).hide();
        $('.cwuploaded-file .text', $form).text('');
    });

    $('.cwfileupload', $form).fileupload({
        dataType: 'json',
        url: '/Engine/UploadContactFiles',
        autoUpload: false,
        replaceFileInput: false,
        fileInput: $("input:file"),
        multiple: false,
        singleFileUploads: true,
        done: function (e, data) {
            form.submit();
        },
        fail: function (e, data) {
            $('.cwfileupload-invalid', $form).show();
        },
        add: function (e, data) {

            form.clearUploadErros();
            formData.contactFileUpload = "";

            var maxFileSize = $("#cwfileupload", $form).data("maxfilesize");

            var fileTypes = $("#cwfileupload", $form).data("acceptfiletypes");
            if (fileTypes) {
                var acceptFileTypes = "(\.|\/)(" + fileTypes + ")$";
                acceptFileTypes = new RegExp(acceptFileTypes, "i");
            }

            var extractExtension = /(?:\.([^.]+))?$/;

            if (acceptFileTypes && data.originalFiles[0]['type'].length && !acceptFileTypes.test(extractExtension.exec(data.originalFiles[0].name)[0])) {
                $('.cwfileupload-invalid', $form).show();
            }
            else if (data.originalFiles[0]['size'] > maxFileSize) {
                $('.cwfileupload-exceeds-max-size', $form).show();
            }
            else {
                $('.cwuploaded-file', $form).show();
                $('.cwuploaded-file .text', $form).text(data.files[0].name);
                $('.cwuploaded-file .js-delete-file', $form).on('click', function (event) {
                    event.preventDefault();

                    form.clearUploadErros();

                    $('.cwfileupload', $form).val('');
                    $('.cwuploaded-file', $form).hide();
                    $('.cwuploaded-file .text', $form).empty();

                    data.files.length = 0;

                    filedata = null;
                    formData.contactFileUpload = "";
                });
                filedata = data;
                formData.contactFileUpload = data.files[0].name;
            }
        }
    });

    Vendd.MessageBus.subscribe(Vendd.Contact.Messages.SubmitSuccess, form, form.onSuccess);
    Vendd.MessageBus.subscribe(Vendd.Contact.Messages.SubmitFailure, form, form.onFailure);
    Vendd.MessageBus.subscribe(Vendd.Plugins.Messages.RecaptcaLoaded, form, form.initRecaptcha);
    Vendd.MessageBus.subscribe(Vendd.Consents.Messages.InsertConsents, form, form.submitSelector);
});

